import type { TrendDirection, TrendSentiment } from '@shared/ui';

export interface AnalyticsTrendSemantics {
  direction: TrendDirection;
  sentiment: TrendSentiment;
}

export function resolveAnalyticsTrend(
  value: number,
  positiveIsGood = true
): AnalyticsTrendSemantics {
  if (!Number.isFinite(value)) {
    return { direction: 'unknown', sentiment: 'neutral' };
  }

  const direction: TrendDirection = value > 0 ? 'up' : value < 0 ? 'down' : 'flat';
  const normalized = positiveIsGood ? value : -value;
  const sentiment: TrendSentiment =
    normalized >= 5
      ? 'positive'
      : normalized > -5
        ? 'neutral'
        : normalized > -10
          ? 'warning'
          : 'negative';

  return { direction, sentiment };
}
